module.exports = __webpack_public_path__ + "static/media/google-cloud.331bc368.png";